/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */

export enum ReservationTypes {
  AUTOMATIC_RESERVATION,
  DEPARTMENT_RESERVATION,
  MANUAL_RESERVATION
}
